
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3><inlineCode parentName="h3">{`enzymeFind`}</inlineCode>{` | v4`}</h3>
    <p>{`A convenience method for finding instances of a particular styled component within an enzyme wrapper.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { mount } from 'enzyme'
import styled from 'styled-components'
import { enzymeFind } from 'styled-components/test-utils'

const Foo = styled.div\`
  color: red;
\`

const wrapper = mount(
  <div>
    <Foo>bar</Foo>
  </div>
)

enzymeFind(wrapper, Foo)
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;